module.exports = __webpack_public_path__ + "static/media/logo.8cc1c3a4.png";